import React from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';
import logo from './ayla-logo.png';

const Landing = () => {
  return (
    <div className="landing-container">
      <div className="landing-content">
        <img src={logo} alt="AYLA" className="logo" />
        <h1>Welcome to AYLA</h1>
        <p>Create a vendor account to start publishing your items!</p>
        <div className="landing-buttons">
          <Link to="/signin" className="btn btn-primary">Sign In</Link>
          <Link to="/signup" className="btn btn-secondary">Sign Up</Link>
        </div>
      </div>
    </div>
  );
};

export default Landing;
